module.exports = __webpack_public_path__ + "static/media/Tony Topping Headshot_1591208816939.799d31b6.png";